const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        cancel: 'Abbrechen',
        confirm: 'Bestätigen',
        continue: 'Weiter',
        back: 'Zurück',
        close: 'Schliessen',
        saveAndClose: 'Speichern und schliessen',
        checkinAbschliessen: 'Check-in abschliessen',
        iConfirm: 'Ich bestätige.',
    },
    __RELATIVE_SOURCE_FILE__
);
